import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'intl-pluralrules';
import "lib/JsTypes.extensions";
import "moment-timezone";
import React from "react";
import ReactDOM from 'react-dom/client';
import reportWebVitals from "reportWebVitals";
import "services/i18n";
import { App } from "views/Root";

const el = document.getElementById('root');
if (el === null) throw new Error('Root container missing in index.html');

const root = ReactDOM.createRoot(el);

if (process.env.REACT_STRICT_MODE === "true") {
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}
else {
    root.render(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
